const dictTypes = [
  'cml_common_whether', // 通用是否
  'cml_packingmaterial_capacityunit', // 包材容量单位
  'cml_packingmaterial_form', // 包材形式
  'cml_packingmaterial_useclassification', // 包材用途分类
  'cml_sample_type', // 样品类型
  'cml_sample_checkstatus', // 样品审核结果
  'cml_sample_status', // 样品状态
  'cml_brand', // 需求品牌
  'odm_product_category', // ODM产品品类
  'odm_product_type', // ODM产品类别
  'odm_product_efficacy', // ODM产品功效
  'odm_suitable_skin', // ODM适合肤质
  'cml_corder_status', // 寻样单状态
  'fabric_type', // 膜布类型
  'fabric_category', // 膜布分类
  'raw_material_category', // 原料分类
  'raw_material_efficacy', // 原料功效
  'raw_material_function', // 原料功能
  'storage_conditions', // 储存条件
  'cml_oorder_status', // 库外寻样单主状态
  'cml_oorder_detail_status', // 库外寻样单明细状态
  'gift_product_type', // 赠品产品类别
  'gift_product_category', // 赠品产品品类-类别的子类
  'cml_pd_first_category',
  'cml_pd_pay_method',
  'cml_pd_service_category',
  'cml_wish_module',
  'cml_wish_it_category',
  'cml_wish_professional_service_category',
  'cml_pd_invoice_type'
];
export default dictTypes;
